import { apiClient, type TourImportJobExEntity } from '@/libs/api'

type CreateTourImportFromCsvJobDto = {
  dcId: number
  fileName: string
  fileKey: string
}

export type CsvTourImportJobsRequest = {
  tenantKey: string
  dto: CreateTourImportFromCsvJobDto
}

/**
 * CSVからの運行実績取込ジョブ作成
 */
export const csvTourImportJobs = async ({
  tenantKey,
  dto
}: CsvTourImportJobsRequest): Promise<TourImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .tour_import_jobs.csv.$post({ body: dto })
  return data
}

/**
 * 運行実績CSV取込テンプレートのダウンロード
 */
export const downloadTourCsvTemplate = async (
  tenantKey: string
): Promise<void> => {
  const response = await apiClient
    ._tenant(tenantKey)
    .tour_import_jobs.csv.template.$get({ config: { responseType: 'blob' } })
  const blob = new Blob([response as unknown as BlobPart], {
    type: 'text/csv; charset=utf-8'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'tour_import_template.csv'
  a.click()
  URL.revokeObjectURL(url)
}
